export async function initNav(container = document) {
    const {gsap} = await import('gsap');

    const menuBtn = container.querySelector('.menu-btn');
    const menuBtnText = container.querySelector('.menu-btn-text');
    const mobileNav = container.querySelector('.mobile-nav');
    const menuOverlay = container.querySelector('.menu-overlay');
    const menuOpen = container.querySelector('.menu-open');
    const menuClose = container.querySelector('.menu-close');

    if (!menuBtn || !menuBtnText || !mobileNav || !menuOverlay || !menuOpen || !menuClose) {
        console.warn('initNav: elements not found, skipping init');
        return;
    }

    const menuItems = mobileNav.querySelectorAll('ul > li');
    let isOpen = false;

    function openMenu() {
        // Zet mobile nav en overlay zichtbaar
        gsap.set([mobileNav, menuOverlay], {display: 'block', visibility: 'visible'});

        // Overlay en menu fade-in
        gsap.to(menuOverlay, {opacity: 0.9, duration: 0.2, pointerEvents: 'auto', ease: "Expo.easeInOut"});
        gsap.to(mobileNav, {opacity: 1, scale: 1, duration: 0.6, ease: "power2.out"});

        // Animatie menu items
        gsap.fromTo(menuItems,
                {x: -10, opacity: 0},
                {x: 0, opacity: 1, stagger: 0.07, duration: 0.6, ease: "power2.out"}
        );

        // Button tekst animatie
        gsap.to(menuBtnText, {
            opacity: 0,
            scale: 0.8,
            duration: 0.2,
            onComplete: () => {
                menuBtnText.textContent = 'Sluiten';
                gsap.to(menuBtnText, {opacity: 1, scale: 1, duration: 0.3});
            }
        });

        isOpen = true;
    }

    function closeMenu() {
        gsap.to(menuItems, {opacity: 0, x: -10, stagger: -0.05, duration: 0.3, ease: "power2.in"});
        gsap.to(mobileNav, {
            opacity: 0, scale: 0.9, duration: 0.2, ease: "power3.in", onComplete: () => {
                mobileNav.style.visibility = 'hidden';
            }
        });
        gsap.to(menuOverlay, {
            opacity: 0, duration: 0.3, ease: "Expo.easeInOut", onComplete: () => {
                menuOverlay.style.visibility = 'hidden';
            }
        });

        gsap.to(menuBtnText, {
            opacity: 0,
            scale: 0.8,
            duration: 0.2,
            onComplete: () => {
                menuBtnText.textContent = 'Menu';
                gsap.to(menuBtnText, {opacity: 1, scale: 1, duration: 0.3, ease: "power2.out"});
            }
        });

        isOpen = false;
    }

    menuBtn.addEventListener('click', () => isOpen ? closeMenu() : openMenu());
    menuOverlay.addEventListener('click', () => {
        if (isOpen) closeMenu();
    });
}
